import LocalStorage from 'quasar/src/plugins/LocalStorage.js';
import { request } from "@/request/api";
import { nickname } from "../lang/zh_CN";

export default {
  data() {
    return {
      my_param, // 读取当前系统后台设置的参数（标题等，由将莱软件设置的参数）
      sys_param, // 读取系统参数（小数位等，由客户设置的参数）
      user_info: [], // 用户资料
      permission: [], // 用户权限
      main_refresh: true,
    }
  },
  async ini() {

    // setTimeout(() => {
    await request("get_param",
      {}
    ).then((res) => {
      // console.log(res);
      if (res) {
        this.my_param = res[0];
        this.sys_param = res[1];

        LocalStorage.set('my_param', res[0]);
        LocalStorage.set('sys_param', res[1]);
      }
    })
    // }, 100);
  },

  /**
   * 获取当前按钮是否需要确认
   * @param {obj} buttons_show 当前显示的按钮数组
   * @param {obj} button 当前按钮名称
   * @param {boolean} is_confirm_status 是否为确认状态
   * @param {boolean} is_confirm_btn 是否为确认按钮
   * @returns 是否需要确认的结果
   */
  get_button_status(buttons_show, button, is_confirm_status, is_confirm_btn = false) {
    is_confirm_status = is_confirm_status == 1 ? true : false;
    // console.log(button);

    let is_show_button =
      buttons_show.find((obj) => obj == button) != undefined;
    let ret = false;

    if (is_confirm_btn) {
      // 是否需要确认的按钮
      ret = is_confirm_status;
    } else {
      ret = !is_confirm_status;
    }

    // console.log(button,
    //   "是否确认按钮：",
    //   is_confirm_btn,
    //   "确认按钮状态：",
    //   is_confirm_status,
    //   "中间值：",
    //   ret
    // );

    ret = is_show_button && ret;

    // console.log("结果:", ret);

    return ret;
  },
  /**
 * @function 实现VBScript的DateAdd功能.
 * @param {string} interval 字符串表达式，表示要添加的时间间隔.
 * @param {integer} number 数值表达式，表示要添加的时间间隔的个数.
 * @param {date} date 时间对象.
 * @returns 新的时间对象.
 * 
 * var now = new Date();
 * var newDate = DateAdd( "d", 5, now);
 *---------------   DateAdd(interval,number,date)   -----------------
 */
  date_add(interval, number, date) {
    switch (interval) {
      case "y": {
        date.setFullYear(date.getFullYear() + parseInt(number));
        break;
      }
      case "q": {
        date.setMonth(date.getMonth() + parseInt(number) * 3);
        break;
      }
      case "m": {
        date.setMonth(date.getMonth() + parseInt(number));
        break;
      }
      case "w": {
        date.setDate(date.getDate() + parseInt(number) * 7);
        break;
      }
      case "d": {
        date.setDate(date.getDate() + parseInt(number));
        break;
      }
      case "h": {
        date.setHours(date.getHours() + parseInt(number));
        break;
      }
      case "m": {
        date.setMinutes(date.getMinutes() + parseInt(number));
        break;
      }
      case "s": {
        date.setSeconds(date.getSeconds() + parseInt(number));
        break;
      }
      default: {
        date.setDate(date.getDate() + parseInt(number));
        break;
      }
    }
    return date;
  },

  // async get_permission (user_id) {
  //   await request("get_permission", {

  //   }).then((res) => {
  //     if (res[0]) {
  //       this.permission = res[1];
  //     } else {
  //       this.permission = [];
  //     }
  //   })
  //   return true;
  // },

  /**
   * 检查请求的权限
   * @param {string} menu_name 菜单名称
   * @param {string} request_type 请求权限（view, new, edit, delete, audit, unaudit, import, export, print）
   * @returns {boolean} 返回是否有该权限
   */
  check_permission(menu_name, request_type) {
    let permission = false;
    if (this.user_info['user_id'] == -1) {
      permission = true;
    } else {
      if (typeof (this.permission[menu_name]) != 'undefined') {
        permission = this.permission[menu_name].indexOf(',' + request_type + ',') >= 0;
      }
    }

    return permission;
  }
  // // 设置信息框显示时长
  // async set_modal_invisible (close_time = 1.2) {
  //   // 显示信息时长
  //   await setTimeout(() => {
  //     console.log('set_modal_invisible');

  //   }, close_time * 1000);

  //   return false;
  // }
}